import React, { useEffect, useState } from "react";
import axios from "axios";
import {
  Box,
  TextField,
  Button,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Paper,
  Chip
} from "@mui/material";
import { usecdotStore } from "../../components/cdotStore";

const OvertimeRequest = () => {
  const baseURL = process.env.REACT_APP_API_URL;

  const emp_id = usecdotStore((state) => state.emp_id);
  const emp_name = usecdotStore((state) => state.username);

  const [form, setForm] = useState({
    date: "",
    hours: "",
    reason: ""
  });

  const [requests, setRequests] = useState([]);

  // 🔹 Fetch my OT requests
  const fetchRequests = async () => {
    try {
      const res = await axios.get(`${baseURL}overtime/my/${emp_id}`);
      setRequests(res.data);
    } catch (err) {
      console.error(err);
    }
  };

  useEffect(() => {
    if (emp_id) {
      fetchRequests();

      // auto today date
      const today = new Date().toISOString().split("T")[0];
      setForm((prev) => ({ ...prev, date: today }));
    }
  }, [emp_id]);

  // 🔹 Handle input
  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  // 🔹 Submit request
  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!form.hours || !form.reason) {
      alert("Please fill all fields");
      return;
    }

    try {
      await axios.post(`${baseURL}overtime/request`, {
        employee_id: emp_id,
        employee_name: emp_name,
        date: form.date,
        requested_hours: form.hours,
        reason: form.reason
      });

      fetchRequests();

      setForm({
        date: form.date,
        hours: "",
        reason: ""
      });

    } catch (err) {
      console.error(err);
      alert("Error submitting request");
    }
  };

  const getStatusColor = (status) => {
    if (status === "approved") return "success";
    if (status === "rejected") return "error";
    return "warning";
  };

  return (
    <Box sx={{ p: 3 }}>
      <h2>Request Overtime</h2>

      {/* 🔥 Request Form */}
      <form onSubmit={handleSubmit} style={{ marginBottom: "20px" }}>
        <Box sx={{ display: "flex", gap: 2, mb: 2 }}>
          <TextField
            type="date"
            name="date"
            value={form.date}
            onChange={handleChange}
            InputLabelProps={{ shrink: true }}
          />

          <TextField
            label="Hours"
            name="hours"
            type="number"
            value={form.hours}
            onChange={handleChange}
          />
        </Box>

        <TextField
          label="Reason"
          name="reason"
          value={form.reason}
          onChange={handleChange}
          fullWidth
          multiline
          rows={2}
        />

        <Button type="submit" variant="contained" sx={{ mt: 2 }}>
          Submit Request
        </Button>
      </form>

      {/* 📊 My Requests */}
      <Paper>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Date</TableCell>
              <TableCell>Requested Hours</TableCell>
              <TableCell>Status</TableCell>
              <TableCell>Manager Remark</TableCell>
            </TableRow>
          </TableHead>

          <TableBody>
            {requests.map((r) => (
              <TableRow key={r.id}>
                <TableCell>{r.date}</TableCell>
                <TableCell>{r.requested_hours}</TableCell>
                <TableCell>
                  <Chip
                    label={r.status}
                    color={getStatusColor(r.status)}
                  />
                </TableCell>
                <TableCell>{r.remark || "-"}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </Paper>
    </Box>
  );
};

export default OvertimeRequest;